<template>
    <div id="konfigurator-pohyb">
        <h1> {{ 'How active is @name?' | translate({'@name': mazlicek.jmeno.value}) }}</h1>

        <div v-show="!isAktivitaValid() && this.tryescape" class="info-messages-box">
            <div v-if="!isAktivitaValid() && this.tryescape" class="error-msg">
                {{ 'You have to select the activity of your dog' | translate }}
            </div>
        </div>

        <div v-if="!mazlicek.jeStene" class="form-content">

            <div class="form-radios"
                 v-bind:class="{ 'has-error':!isAktivitaValid() && this.tryescape,'has-success':isAktivitaValid()  && this.tryescape}">
                <div class="form-type-radio" v-for="item in pohybItems">
                    <input type="radio" v-model="mazlicek.pohyb.id" v-bind:value="item.id" :id="item.id">
                    <label :for="item.id">
                        <div class="item-title">{{ item.title }}</div>
                        <div v-if="item.description.length > 0" class="item-desc" v-html="item.description"></div>
                    </label>
                </div>
            </div>
        </div>
        <info v-if="!mazlicek.jeStene" :krok="7"></info>

        <div v-else class="infobox">{{
            "For an adult dog, you have to select how active it is. For puppies, this is not relevant for the calculation of Haffit. Choose the 'Continue' button."
            | translate}}
        </div>

        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :disableNext="!valid"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>

    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    import {apiSilex} from '../api'
    import navigace from './Navigace'
    import info from './Info'

    export default {
        components: {navigace, info},
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                pohybItems: [],
                tryescape: false
            }
        },
        computed: {
            valid: function () {
                return (this.mazlicek.pohyb.valid = !this.$v.mazlicek.pohyb.$invalid)
            }
        },
        methods: {
            prev: function () {
                this.$router.push({name: 'hmotnostkondice'})
            },
            saveAndQuit: function () {
              if (this.isAktivitaValid()) {
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    window.location.href = 'prihlaseni'
                  }, error => {
                    console.error(error)
                  })
              } else {
                this.tryescape = true
                this.animateAfterError()
              }
            },
            next: function () {
                // this.$store.commit('setMazlicek', this.mazlicek)
                if (this.isAktivitaValid()) {
                    this.$store.dispatch('updatePet', this.mazlicek)
                        .then(response => {
                            this.$router.push({name: 'alergie'})
                        }, error => {
                            console.error(error)
                        })
                } else {
                    this.tryescape = true
                    this.animateAfterError()
                }
            },
            isAktivitaValid: function () {
                return this.mazlicek.pohyb.id !== null || this.mazlicek.jeStene
            },
            animateAfterError(){
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            }
        },
        mounted: function () {
            this.mazlicek.step.current = 7
            this.$cookies.set('lastVisitedStep', 7)
            jQuery('html, body').animate({scrollTop: 0}, '500')
            apiSilex.get('/aktivita').then(response => (this.pohybItems = response.data))
        },
        validations: {
            mazlicek: {
                pohyb: {
                    id: {
                        required
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// 07Pohyb.vue?db7ba308